import React from 'react'
import prefetchProfileReviews from 'graphql/prefetchers/prefetchProfileReviews'
import { initializeApollo } from 'lib/apolloClient'
import locationTemporaryRewrite from 'lib/locationTemporaryRewrite'
import { isServer } from 'lib/utils'
import { NextPageContext } from 'next'

import ProfileNotFoundPage from 'components/NotFound/ProfileNotFoundPage'
import ReviewsModal from 'components/ReviewsModal/ReviewsModal'
import usePublicReviews from 'hooks/usePublicReviews'

function ReviewsPage(): JSX.Element {
  const { name } = usePublicReviews()
  if (!name) {
    return <ProfileNotFoundPage />
  }
  return <ReviewsModal showProfile />
}

ReviewsPage.getInitialProps = async (ctx: NextPageContext) => {
  const { query, req, res } = ctx
  const { slug } = query

  if (isServer()) {
    const apolloClient = initializeApollo(ctx)
    const profile = await prefetchProfileReviews(apolloClient, { slug })
    const profileSlug = profile?.data?.market?.profile?.slug
    // An old slug of the profile accessed, redirecting
    if (profileSlug && profileSlug !== slug) {
      locationTemporaryRewrite(res, req.url.replace(String(slug), profileSlug))
    }

    return {
      initialApolloState: apolloClient.cache.extract(),
    }
  }

  return {}
}

export default ReviewsPage
